const _ = require("lodash");
import { Meal } from "./Meal";
import { Recipe, Ingredient } from "./Recipe";
import {
  ShoppingListEntry,
  RecipeShoppingListEntry,
  ManualShoppingListEntry,
} from "@/models/ShoppingListEntry";

class ShoppingList {
  entries: Array<ShoppingListEntry>;
  historicEntries: Array<ShoppingListEntry>;

  constructor() {
    this.entries = [];
    this.historicEntries = [];
  }

  obsoleteHistoricEntries(): Array<ShoppingListEntry> {
    const KEEP_NEWEST_COUNT = 5;
    let obsoleteEntries: Array<ShoppingListEntry> = [];
    const ingredientList: Array<string> = _.uniq(
      this.historicEntries.map((entry) => entry.ingredient.name)
    );

    ingredientList.forEach((ingredientName) => {
      const ingredientEntries = this.historicEntries.filter(
        (entry) => entry.ingredient.name === ingredientName
      );

      if (ingredientEntries.length <= KEEP_NEWEST_COUNT) {
        return;
      }

      const removeCount = ingredientEntries.length - KEEP_NEWEST_COUNT;

      obsoleteEntries.push(
        ..._.take(
          _.sortBy(
            ingredientEntries,
            (entry: ShoppingListEntry) => entry.shoppedAt
          ),
          removeCount
        )
      );
    });
    return obsoleteEntries;
  }
}

interface Geolocation {
  latitude: number;
  longitude: number;
}

export { ShoppingList, Geolocation };
